module.exports = __webpack_public_path__ + "static/logo-ef568d4cde27a3b6fbe788116ffc0676.svg";